import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen } from '@phosphor-icons/react';
import MarkdownDocPage from '../components/MarkdownDocPage';
import { useAuth } from '../auth/AuthContext';

export const HowToUsePage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  // Customers with Smart Saver disabled shouldn't see the Smart Saver overview.
  useEffect(() => {
    if (user?.role === 'customer' && user?.smartSaverEnabled === false) {
      navigate('/browse', { replace: true });
    }
  }, [user, navigate]);
  return (
    <MarkdownDocPage
      apiPath="/docs/how-to-use"
      title="Smart Saver Overview"
      subtitle="A short walkthrough of the app — first-time sign-in, ordering, Smart Saver, and prepayment."
      icon={<BookOpen size={32} weight="duotone" className="text-gold" />}
      downloadFilename="Raiseys-Smart-Saver-Overview.md"
      printTitle="Raisey's Smart Saver — Overview"
      testIdPrefix="how-to-use"
      printableId="how-to-use-printable"
    />
  );
};

export default HowToUsePage;
